import { fetch } from '@/utils/request';

// 会员
const memberIndex = (param, callback) => fetch('/admin/member/index','GET', param, callback);
const memberDetail = (param, callback) => fetch('/admin/member/detail','GET', param, callback);
const memberInfo = (param, callback) => fetch('/admin/member/detail','GET', param, callback);
const memberUpadte = (param, callback) => fetch('/admin/member/update','POST', param, callback);
const memberShenhe = (param, callback) => fetch('/admin/member/shenhe','POST', param, callback);
const memberSetGrade = (param, callback) => fetch('/admin/member/setGrade','POST', param, callback);
const memberIntegralUpda = (param, callback) => fetch('/admin/member/integral/update','POST', param, callback);
const memberIntegralList = (param, callback) => fetch('/admin/member/integral/list','GET', param, callback);
const memberBalanceUpda = (param, callback) => fetch('/admin/member/balance/update','POST', param, callback);
const memberBalanceList = (param, callback) => fetch('/admin/member/balance/list','GET', param, callback);
const memberSetParent = (param, callback) => fetch('/admin/member/setParent','POST', param, callback);
const memberCommissionUpda = (param, callback) => fetch('/admin/member/commission/update','POST', param, callback);
const memberCommissionList = (param, callback) => fetch('/admin/member/commission/list','GET', param, callback);
const memberCommissionOrder = (param, callback) => fetch('/admin/member/commission/order','GET', param, callback);
const memberCommissionOrderDetail = (param, callback) => fetch('/admin/member/commission/order/detail','GET', param, callback);
const memberLog = (param, callback) => fetch('/admin/member/log','GET', param, callback);

// 会员等级
const memberGradeIndex = (param, callback) => fetch('/admin/member/grade/index','GET', param, callback);
const memberGradeInfo = (param, callback) => fetch('/admin/member/grade/detail','GET', param, callback);
const memberGradeAdd = (param, callback) => fetch('/admin/member/grade/add','POST', param, callback);
const memberGradeEdit = (param, callback) => fetch('/admin/member/grade/edit','POST', param, callback);
const memberGradeDel = (param, callback) => fetch('/admin/member/grade/del','POST', param, callback);

export default {
  memberIndex,
  memberDetail,
  memberInfo,
  memberUpadte,
  memberShenhe,
  memberSetGrade,
  memberIntegralUpda,
  memberIntegralList,
  memberBalanceUpda,
  memberBalanceList,
  memberSetParent,
  memberCommissionUpda,
  memberCommissionList,
  memberCommissionOrder,
  memberCommissionOrderDetail,
  memberLog,

  memberGradeIndex,
  memberGradeInfo,
  memberGradeAdd,
  memberGradeEdit,
  memberGradeDel,

}
